import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const EventGifts = () => {
  const CTAContent = [
    {
      pageName: "Event Gifts",
      paragraphitalic: "Make Every Event Unforgettable",
      paragraphText:
        "Improve conferences, seminars, and trade shows with branded event gifts that attendees will cherish. From custom giveaways to innovative promotional products, we help you stand out in any crowd.",
      ContactFormName: "Event Gifts",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Custom Keepsakes",
      parapgraphItalic: "Create souvenirs that last ",
      sectionparagraphText: (
        <>
          <p>
            Create personalized souvenirs that speak volumes about your brand and event. 
          </p>
          <p>
          We believe every event deserves a lasting impression. Our custom keepsakes are designed to capture the essence of your brand while offering recipients a timeless memento. Whether you're celebrating a corporate milestone, recognizing a team achievement, or hosting a special event, our keepsakes make your brand stays memorable long after the event has ended.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/event-gifts/Custom Keepsakes.jpg",
    },
    /**Catagory Img */
    {
      index: 1,
      sectionName: "Engagement Boosters",
      parapgraphItalic: "Promote your event experience.",
      sectionparagraphText: (
        <>
          <p>
            Make every attendee feel special with unique, engaging gifts that spark interaction and excitement. 
          </p>
          <p>
            Why settle for ordinary when you can create extraordinary experiences? With eYantra’s Engagement Boosters, you can create interaction, spark curiosity, and keep attendees talking long after your event has ended. Whether it’s a corporate launch, a trade show, or a team-building workshop, these gifts are designed to keep your audience excited and engaged. 
          </p>
        </>
      ),
      ImgSrc: "../assests/images/event-gifts/Engagement Boosters.jpg",
      categoryHeadingLeftSide: "What do we include?",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/event-gifts/Interactive Gift Options.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Interactive Gift Options</b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/event-gifts/Tech-Savvy Choices.png",
          CategoryName: <>
          <p className="fs-14">
            <b>Tech-Savvy Choices</b> <br></br>
          </p>
        </>,
        },
        {
          CategoryImg: "../assests/images/event-gifts/Custom Branding.png",
          CategoryName: <>
          <p className="fs-14">
            <b>Custom Branding</b> <br></br>
          </p>
          </>,
        },
      ],
    },
  ];
  const noGapContent = [
    {
      RightImgNogap: "../assests/images/event-gifts/What do we include.jpg",
      NogapHeading: "What do we include? ",
      Heading: [
        {
          ListHeading: "Personalized Designs",
          ListParagraph: "Add logos, names, or event themes to every item. Let your creativity shine while aligning with your brand message.",
        },
        {
          ListHeading: "Diverse Product Range",
          ListParagraph: "From elegant photo frames and trophies to functional items like personalized mugs and desk accessories, we have a wide variety of custom keepsakes to suit your event needs.",
        },
        {
          ListHeading: "Premium Quality",
          ListParagraph: "Crafted from high-quality materials to make sure durability and timeless appeal. Your keepsakes will stand the test of time, just like the memories they represent.",
        },
      ],
    },
      {
        RightImgNogap: "../assests/images/event-gifts/Creative Packaging.jpg",
        NogapHeading: "Creative Packaging",
        paragraphItalic:"Guaranteed memorable unboxing moments",
        paragraphDetail:(
          <>
            <p>
              Transform every gift into a memorable unboxing experience that’s as exciting as the gift itself. 
            </p>
            <p>
              The presentation is just as important as the gift inside. At eYantra, we specialize in creating packaging that’s designed to surprise, delight, and elevate your gifting experience. Whether you're gifting a small token or a premium product, our creative packaging certifies that the moment your recipient opens their gift, they’re met with an unforgettable experience.
            </p>
          </>
        ),
        
        NogapSubheading:"What do we include?",
        Categories: [
          {
            ServiceImg: "../assests/images/event-gifts/Luxurious Designs.png",
            ServiceText: (
              <>
                <p className="fs-14">
                  <b>Luxurious Designs</b> 
                </p>
              </>
            ),
          },
          {
            ServiceImg: "../assests/images/event-gifts/Tailored to Your Event.png",
            ServiceText: (
              <>
                <p className="fs-14">
                  <b>Tailored to Your Event</b> 
                </p>
              </>
            ),
          },
          {
            ServiceImg: "../assests/images/event-gifts/Memorable Unboxing.png",
            ServiceText: (
              <>
                <p className="fs-14">
                  <b>Memorable Unboxing</b>
                </p>
              </>
            ),
          },
        ],
        
    
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
      NogapHeading: "Milestone Recognition ",
      paragraphItalic: "Make sure every gift reflects excellence.",
      paragraphDetail: (
        <>
          <p>
          Appreciate dedication and achievements. 
          </p>
          <p>
            Show appreciation for the hard work and dedication that goes into every achievement. 
          </p>
          <p>
          Milestones such as work anniversaries, project completions, and promotions deserve to be celebrated. At eYantra, we provide a range of premium milestone gifts that are as unique as the achievements. 
          </p>
        </>
      ),

      NogapSubheading: "Our Milestone Gift Options Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: (
            <>
                 
                <p className="fs-14">
                <b>Personalized Awards</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: (
            <>
            <p className="fs-14">
                <b>Luxury Gift Hampers</b> 
              </p>
                 
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: (
            <>
                <p className="fs-14">
                <b>Luxury Gift Hampers</b>
              </p>

            </>
          ),
        },
      ],
    },
  ];
 
    
  
  return (
    <>
        <Helmet>
           <title> Event Gifts</title>
        </Helmet>
        <div className="p-0 m-2">
        <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]}/>
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]}/> 
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Impress your audience with gifts that align with your event’s theme and brand vision.
      </p>
    </>
  );
};

export default EventGifts;
